








































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import {
  ContextType,
  ContextTypes,
  IContent,
  IContext,
  LocationType,
  LocationTypes,
  LocationTypeType,
  LocationTypeTypes,
  OsmType,
  OsmTypes,
} from '../models';

@Component({
  components: {},
})
export default class AddContextCard extends Vue {
  @Prop({ default: () => ({}) }) public item!: Partial<IContent>;
  private types: ContextType[] = [...ContextTypes];
  private locationTypes: LocationType[] = [...LocationTypes];
  private activeLocationType: LocationType = 'NAME';
  private locationTypeTypes: LocationTypeType[] = [...LocationTypeTypes];
  private activeLocationTypeType: LocationTypeType = 'LIST';
  private osmTypes = OsmTypes;
  private activeOsmType: OsmType = {} as OsmType;
  private activeType: ContextType = 'NONE';
  private activeLat = 0.0;
  private activeLon = 0.0;
  private activeKey = '';
  private activeVal = '';
  private newContext: IContext = { type: 'NONE', data: {} };

  @Watch('item', { deep: true })
  private itemChanged() {
    console.log(`Item changed`);
    this.resetNewItem();
    if (this.item && this.item.context) {
      this.activeType = this.item.context.type;
      if (this.activeType === 'LOCATION') {
        this.activeLocationType = (Object.keys(this.item.context.data).shift() as LocationType) || 'NAME';
        this.activeVal = Object.values(this.item.context.data).shift() || '';
        if (this.activeLocationType === 'COORDINATES') {
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          this.activeLat = this.activeVal.includes(',') ? +this.activeVal.split(',').shift()! : 0;
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          this.activeLon = this.activeVal.includes(',') ? +this.activeVal.split(',').pop()! : 0;
        }
      } else if (this.activeType === 'LOCATIONTYPE') {
        this.activeLocationTypeType = 'CUSTOM';
        this.activeKey = Object.keys(this.item.context.data).shift() || '';
        this.activeVal = Object.values(this.item.context.data).shift() || '';
      } else {
        this.activeKey = Object.keys(this.item.context.data).shift() || '';
        this.activeVal = Object.values(this.item.context.data).shift() || '';
      }
    }
  }

  constructor() {
    super();
  }

  private typeSelected() {
    this.newContext = { type: this.activeType, data: {} };
  }

  private async addItem() {
    this.newContext.type = this.activeType;
    if (this.activeType === 'LOCATION') {
      if (this.activeLocationType === 'COORDINATES') {
        this.newContext.data[this.activeLocationType] = `${this.activeLat},${this.activeLon}`;
      } else {
        this.newContext.data[this.activeLocationType] = this.activeVal;
      }
    } else if (this.activeType === 'LOCATIONTYPE') {
      if (this.activeLocationTypeType === 'CUSTOM') {
        this.newContext.data[this.activeKey] = this.activeVal;
      } else if (this.activeLocationTypeType === 'LIST') {
        this.newContext.data[this.activeOsmType.key] = this.activeOsmType.value;
      }
    } else {
      this.newContext.data[this.activeKey] = this.activeVal;
    }
    this.item.context = Object.assign({}, this.newContext) as IContext;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    this.$store.actions[this.item.type!].save(this.item);
    this.$emit('close');
  }

  private resetNewItem() {
    this.activeKey = '';
    this.activeVal = '';
    this.activeType = 'NONE';
  }

  private async cancel() {
    this.$emit('close');
  }

  async mounted(): Promise<void> {
    console.log(`Add context card mounted`);
    this.itemChanged();
  }
}
